import { useState } from "react";
import { Button, Tag } from "rsuite";
import { getDate } from "../../../utils/dateFormatter";

export function DepositSubmit({ data, booked }) {
  const [toggle, setToggle] = useState(false);
  return (
    <>
      <div className="card containerd w-75">
        <div
          style={{ backgroundColor: "rgba(242, 89, 38)" }}
          className="card-header text-white py-3"
        >
          <h2>Submit</h2>
        </div>

        <div className="card-body p-3 ">
          <div>
            {!booked && (
              <label style={{ fontSize: 14, marginBottom: 10 }}>
                Thank you for filling out the reservation form. Please click on
                the submit button below. We will then be in touch soon to
                provide instructions on how to pay your initial deposit.
              </label>
            )}
          </div>
          {booked && (
            <>
              <Tag color="green" className="w-100 my-2">
                <div
                // style={{ backgroundColor: "green" }}
                // className="card-header text-white py-3"
                >
                  <h2>Reservation saved successfully!</h2>
                </div>
              </Tag>
              <label
                style={{
                  fontSize: 14,
                  marginBottom: 10,
                }}
              >
                Thank you for completing the online reservation form. We will be
                in touch soon to provide instructions on how to pay your initial
                deposit.
              </label>
            </>
          )}
          <Button
            className="bg-color-default text-white w-100"
            onClick={() => setToggle(!toggle)}
          >
            Show Summary
          </Button>
          {toggle && (
            <div class="containerd my-5 mt-0 px-5 py-5 pt-0">
              <div class="container-fluid invoice-letter mt-3">
                <div
                  // style={{ backgroundColor: "gray" }}
                  class="bg-generic d-flex justify-content-center align-items-center"
                >
                  <img
                    width="200px"
                    style={{ objectFit: "contain", paddingTop: 10 }}
                    src="/logo.png"
                  />
                </div>
                {/* <div class="row">
                  <div class="col-3 text-white pl-5 py-2 letter-title">
                    <h5>Summary</h5>
                  </div>
                  <div class="col-9 text-white pr-5 py-2 letter-content">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Praesent consequat erat mauris, a scelerisque est
                      pellentesque vel. Proin tempus felis purus, vel molestie
                      nisl condimentum nec.
                    </p>
                  </div>
                </div> */}
              </div>

              {data?.map((ele) => {
                return (
                  <>
                    {ele?.title === "Secondary Traveler's Information" &&
                    ele?.data?.secondary_full_name?.length == 0 ? null : (
                      <div class="row table mt-5">
                        <table class="invoice table table-hover">
                          <thead class="thead">
                            <tr>
                              <th colSpan={2} scope="col">
                                <h4>{ele?.title}</h4>
                              </th>
                            </tr>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.entries(ele?.data).map(([key, value]) => {
                              if (
                                key === "booking_number" ||
                                key === "user_id" ||
                                key === "tour_id" ||
                                key === "tour_uuid" ||
                                key === "datesAndCities" ||
                                value === null
                              ) {
                                return null;
                              } else
                                return (
                                  <tr>
                                    <th scope="row">
                                      {key
                                        ?.replaceAll("_", " ")
                                        .toUpperCase()
                                        .replaceAll("SECONDARY", "")}
                                    </th>
                                    <td class="item">
                                      {/*{typeof value === "object"*/}
                                      {/*  ? getDate(value)*/}
                                      {/*  : value}*/}
                                      {value == 0 ? 'No' : (value == null ? "N/A" : (key !== 'number_of_passengers' && value == 1 ? 'Yes' : value))}
                                    </td>
                                  </tr>
                                );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
